/*eslint-disable */
import root from '../_helpers/roots';
let paypalOrderUrlLink = root.paypalOrderUrlLink.link;
let getpaypalSubscriptionUrlLink = root.getpaypalSubscriptionUrlLink.link;
let getpaypalSubscriptionPlansUrlLink = root.getpaypalSubscriptionPlansUrlLink.link;
let paypalPaymentConfirmLink = root.paypalPaymentConfirmLink.link
let paymentHistoryLink = root.paymentHistoryLink.link
import Vue from 'vue'
import axios from 'axios';
export default {
    state: {
        orderCreateDataState: {},
        getPlanDataDetails: {},
        getPaypalPlanDataDetails: {},
        getPaypalConfirmationDetails: {},
        getPaymentHistoryDetails:{}
    },
    mutations: {
        createPaypalOrderData(state, value) {
            Vue.set(state, 'orderCreateDataState', value)
        },
        getPaypalSubscriptionData(state, value) {
            Vue.set(state, 'getPlanDataDetails', value)
        },
        getPaypalSubscriptionPlanData(state, value) {
            Vue.set(state, 'getPaypalPlanDataDetails', value)
        },
        getPaypalConfirmationData(state, value) {
            Vue.set(state, 'getPaypalConfirmationDetails', value)
        },
        getPaymentHistoryFun(state, value) {
            Vue.set(state, 'getPaymentHistoryDetails', value)
        },
    },
    actions: {
        // Get Paypal Order Details
        getPaypalOrderDetails(context, payload) {
            return new Promise((resolve, reject) => {
                axios.post(paypalOrderUrlLink, payload).then(res => {
                    context.commit('createPaypalOrderData', res.data);
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Get Paypal Payment Subscription Details
        getPaypalSubscriptionDetails(context) {
            return new Promise((resolve, reject) => {
                axios.get(getpaypalSubscriptionUrlLink).then(res => {
                    context.commit('getPaypalSubscriptionData', res.data);
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Get Paypal Payment Subscription Plan Details
        getPaypalSubscriptionPlansDetails(context) {
            return new Promise((resolve, reject) => {
                axios.get(getpaypalSubscriptionPlansUrlLink).then(res => {
                    context.commit('getPaypalSubscriptionPlanData', res.data);
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Get Paypal Payment Confirmation By Id
        getPaypalPaymentConfirmationById(context, payload) {
            return new Promise((resolve, reject) => {
                axios.get(paypalPaymentConfirmLink + payload.order_id + '/').then(res => {
                    context.commit('getPaypalConfirmationData', res.data);
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        getPaymnetHistories(context, payload) {
            return new Promise((resolve, reject) => {
                axios.get(paymentHistoryLink).then(res => {
                    context.commit('getPaymentHistoryFun', res.data);
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        }
    },
    getters: {
        getUserOrderId: state => state.orderCreateDataState,
        getPlanDataState: state => state.getPlanDataDetails,
        getPaypalPlanDataDetailsState: state => state.getPaypalPlanDataDetails,
        getPaypalConfirmationDetailsState: state => state.getPaypalConfirmationDetails,
        getPaymentHistoryDetailsState: state => state.getPaymentHistoryDetails
    }
}